/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class MastographyFindingService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.MASTOGRAPHYFINDING_LISTALL_PAGINATION, params);
  }
  static get(params) {
    return this.postSEC(ServiceConstant.MASTOGRAPHYFINDING_GET, {idTypeFinding: params.idTypeFinding});
  }
  static add(params) {
    return this.postSEC(ServiceConstant.MASTOGRAPHYFINDING_ADD, params);
  }
  static delete(params) {
    return this.postSEC(ServiceConstant.MASTOGRAPHYFINDING_DELETE, params);
  }
  static update(params) {
    return this.postSEC(ServiceConstant.MASTOGRAPHYFINDING_UPDATE, params);
  }
  static listAll(){
    return this.getSEC(ServiceConstant.MASTOGRAPHYFINDING_LISTALL);
  }
}
